import React from 'react'

const IconSvg = () => {
  const primaryColor = 'var(--clr-primary-400)'

  return (
    <svg
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7.5 1.25C4.05 1.25 1.25 4.05 1.25 7.5C1.25 10.95 4.05 13.75 7.5 13.75C10.95 13.75 13.75 10.95 13.75 7.5C13.75 4.05 10.95 1.25 7.5 1.25ZM8.125 10.625H6.875V6.875H8.125V10.625ZM8.125 5.625H6.875V4.375H8.125V5.625Z'
        fill='url(#paint0_linear_3179_3003)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_3179_3003'
          x1='1.25'
          y1='7.50199'
          x2='13.754'
          y2='7.50199'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#17A2C3' />
          <stop offset='1' stopColor={primaryColor} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default IconSvg
